import React from "react";
import { observer } from "mobx-react";
import { DataGrid } from "@mui/x-data-grid";

const QTable = observer(({ store }) => {
  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "quoteNr",
      headerName: "new quoteNr",
      width: 120,
      valueFormatter: ({ value }) => {
        return parseInt(value);
      },
    },
    {
      field: "user",
      headerName: "User",
      width: 150,
      // editable: true,
      valueFormatter: ({ value }) => {
        return value.replace("@eocgroup.com", "").replace(".", " ");
      },
    },
    {
      field: "sapAction",
      headerName: "Action",
      width: 150,
      editable: true,
    },
    {
      field: "createdOn",
      headerName: "Creation date",
      type: "date",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "data",
      headerName: "shipTo",
      minWidth: 240,
      flex: 1,
      valueFormatter: ({ value }) => {
        return parseInt(value.Shiptonr) + " => " + value.Shiptoname;
      },
    },
  ];
  return (
    <div style={{ height: "80vh", width: "100%", position: "relative" }}>
      <DataGrid
        rows={store.arr}
        columns={columns}
        // pageSize={store.showRows}
        // rowsPerPageOptions={[5, 15, 25, 50]}
        // checkboxSelection
        onRowClick={(val) => {
          console.log(val);
          console.log(val.row);
          store.quote = { ...val.row, Data: val.row.data };
        }}
        autoPageSize
      />
    </div>
  );
});

export default QTable;
